import { ChatBotSettingsFormValues } from "@jugl-web/domain-resources/chat-bot";
import { Radio } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { InputNumberPixel } from "./InputNumberPixel";
import { InfoIndicator } from "../../../../../components/InfoIndicator";

export const PositionSection: FC = () => {
  const { t } = useTranslations();
  const { control } = useFormContext<ChatBotSettingsFormValues>();

  const alignmentOptions: Array<{
    label: string;
    value: "right" | "left";
  }> = [
    {
      label: t({
        id: "client-support-page.left-alignment",
        defaultMessage: "Left alignment",
      }),
      value: "left",
    },
    {
      label: t({
        id: "client-support-page.right-alignment",
        defaultMessage: "Right alignment",
      }),
      value: "right",
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <span className="ml-2 font-secondary text-sm text-dark-700">
          {t({
            id: "client-support-page.position",
            defaultMessage: "Icon Position",
          })}
        </span>

        <InfoIndicator
          message={t({
            id: "client-support-page.position-tooltip",
            defaultMessage: "Set where your chat widget appears on the website",
          })}
        />
      </div>

      <div className="flex flex-col gap-6">
        <div className="ml-1 flex gap-6">
          <Controller
            control={control}
            name="alignment"
            render={({ field: { value, onChange } }) => (
              <>
                {alignmentOptions.map((option) => (
                  <label
                    key={option.value}
                    className={cx(
                      "flex items-center gap-2",
                      value !== option.value && "cursor-pointer"
                    )}
                  >
                    <Radio
                      value={option.value}
                      isChecked={value === option.value}
                      onChange={(e) => {
                        if (e.target.checked) {
                          onChange(option.value);
                        }
                      }}
                      size="lg"
                    />
                    <span className="font-secondary text-sm text-dark">
                      {option.label}
                    </span>
                  </label>
                ))}
              </>
            )}
          />
        </div>
        <Controller
          control={control}
          name="bottomSpacing"
          render={({ field: { value, onChange } }) => (
            <InputNumberPixel
              label={t({
                id: "client-support-page.bottom-spacing",
                defaultMessage: "Bottom spacing",
              })}
              value={value}
              onChange={onChange}
            />
          )}
        />
        <Controller
          control={control}
          name="sideSpacing"
          render={({ field: { value, onChange } }) => (
            <InputNumberPixel
              label={t({
                id: "client-support-page.side-spacing",
                defaultMessage: "Side spacing",
              })}
              value={value}
              onChange={onChange}
            />
          )}
        />
      </div>
    </div>
  );
};
